import check from './check'
import modal from './modal'

export default {
  install(Vue) {
    // 模态框对象
    Vue.prototype.$modal = modal

    // 加载全局检测方法
    Vue.prototype.$check = check
  },
}
